<template>
  <Exception type="403" />
</template>

<script>
import Exception from '@/components/Exception';

export default {
  components: { Exception },
};
</script>
